import request from "@/utils/request";
import ENDPOINT from "@/config/endpoint";

export async function fetchUserRegister(params) {
  return await request({
    url: ENDPOINT.HOME_REGISTER_CONSULTATION,
    method: "get",
    params,
  });
}